module.exports = __webpack_public_path__ + "static/media/T14-T25-05-01.beee531d.svg";